export default "__VITE_ASSET__BGko$sSU__"